






	import Vue from 'vue';
    import ModListUserGuildLogEntryComp from "./ModListUserGuildLogEntryComp.vue";

    export default Vue.extend({
        name: "ModListUserGuildLogComp",
        components: {ModListUserGuildLogEntryComp},
        props: ['log']
    })
